export enum QuestionType
{
    YesNo,
    Scale,
    SingleChoice,
    MultipleChoice,
    Opened
}